import { render, staticRenderFns } from "./headerProfile.vue?vue&type=template&id=d12a024a&"
import script from "./headerProfile.vue?vue&type=script&lang=js&"
export * from "./headerProfile.vue?vue&type=script&lang=js&"
import style0 from "./headerProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports